import { createReducer, on } from "@ngrx/store";
import { RoleState } from "./Role.state";
// import { duplicateUserSuccess, fetchmenusuccess, getrolesuccess, getuserbycodesuccess, getuserssuccess } from "./User.action";
import { getrolessuccess } from "./Role.action";

const _roleReducer = createReducer(RoleState,
    on(getrolessuccess, (state, action) => {
        return { ...state.rolelist, ...action.rolelist }
    }),
    // on(getrolessuccess, (state, action) => {
    //     return RoleAdapter.setAll(action, state)
    // }),
)

export function RoleReducer(state: any, action: any) {
    return _roleReducer(state, action);
}